import { createDecoder } from './minimp3-wasm.js';
import {NOT_UPLOADED_YET} from 'constants/ipfs-constants.js';
import Sample from 'repos/Sample.js';
import Tone from 'tone';

let decoder;
export const decodeMP3 = async (mp3Data) => {
    let url = window.isNFT ? 'decoder.opt.wasm' : '/decoder.opt.wasm';
    console.log("DECODE URL =", url);
    const decoder = await createDecoder(mp3Data, url);
    const merged = new Uint16Array(mp3Data.length*6);
    let position=0;
    let sampleRate;
    decoder.seek(0);
    let counter=0;
    const results = decoder.decode(60*5.5);
    sampleRate = results.samplingRate;
    merged.set(results.pcm, position);
    position+=results.pcm.length;

    let ctxt = Tone.Master.context;
    const _buffer = ctxt.createBuffer(2, position/2, 44100);
    const channelDataL = _buffer.getChannelData(0);
    const channelDataR = _buffer.getChannelData(1);
    // int16 -> float32
    for (let i = 0; i < merged.length; i+=2) {
      const l = merged[i];
      const r = merged[i+1];
      channelDataL[i/2] = l >= 32768 ? -(65536 - l) / 32768 : l / 32767;
      channelDataR[i/2] = r >= 32768 ? -(65536 - r) / 32768 : r / 32767;
    }
    return _buffer;
};

export const initMP3 = async (engine) => {
    /*
    let name = "/completed_live_0bf4d6d54e4b03be05f1a24f090ee4d0_vocals.mp3";
    const res = await fetch(name);
    const buffer = await res.arrayBuffer();
    const mp3Data = new Uint8Array(buffer);
    const decoder = await createDecoder(mp3Data, '/decoder.opt.wasm');
    decoder.seek(0);
    const results = decoder.decode(30);
    let pcm = results.pcm;
    console.log(pcm);
    let ctxt = Tone.Master.context;
    const _buffer = ctxt.createBuffer(2, pcm.length/2, results.samplingRate);
    const channelDataL = _buffer.getChannelData(0);
    const channelDataR = _buffer.getChannelData(1);
    // int16 -> float32
    for (let i = 0; i < pcm.length; i+=2) {
      const l = pcm[i];
      const r = pcm[i+1];
      channelDataL[i/2] = l >= 32768 ? -(65536 - l) / 32768 : l / 32767;
      channelDataR[i/2] = r >= 32768 ? -(65536 - r) / 32768 : r / 32767;
    }
    let sample = new Sample(NOT_UPLOADED_YET);
    sample.audioBuffer = _buffer;
    sample.needsSave = true;
    // await sample.fetchAudio();
    sample.tags = [];
    sample.name = "test";
    await engine.addSound(sample);
    */
};
